<template>
  <div class="newIndex">
    <div class="menu_list">

      <div class="menu_Info">
        <div class="img"><img src="/status/phone/6.png"></div>
        <div class="menu_right">
          <div class="text">极速服务应答</div>
          <div class="border"></div>
          <div class="title">快速应答为业务保驾护航</div>
        </div>
      </div>
      <div class="menu_Info">
        <div class="img"><img src="/status/phone/7.png"></div>
        <div class="menu_right">
          <div class="text">全天候品质服务</div>
          <div class="border"></div>
          <div class="title">7x24小时专业工程师服务</div>
        </div>
      </div>
      <div class="menu_Info">
        <div class="img"><img src="/status/phone/8.png"></div>
        <div class="menu_right">
          <div class="text">客户价值为先</div>
          <div class="border"></div>
          <div class="title">从服务价值到创造客户价值</div>
        </div>
      </div>
      <div class="menu_Info">
        <div class="img"><img src="/status/phone/9.png"></div>
        <div class="menu_right">
          <div class="text">全方位安全保障</div>
          <div class="border"></div>
          <div class="title">打造一款透明可信的软件</div>
        </div>
      </div>
    </div>
    <div class="card_list">
      <div class="card_info">
        <div class="card_info_image">
          <img src="/status/phone/2.png">
        </div>
        <div class="card_info_right">
          <div class="card_top">
            <div class="card_text">专精特新·智慧医疗</div>
            <div class="card_title">i</div>
          </div>
          <div class="border"></div>
          <div class="card_bottom_text">作为专精特新企业，我们聚焦医疗科技细分需求，专注智慧医疗技术研发与产业化;以融合人工智能与生物医学工程的特色技术，打造差异化医疗解决方案。</div>
        </div>
      </div>
      <div class="card_info2">
        <div class="card_info_image">
          <img src="/status/phone/3.png">
        </div>
        <div class="card_info_right">
          <div class="card_top">
            <div class="card_text">高新技术企业</div>
            <div class="card_title">i</div>
          </div>
          <div class="border"></div>
          <div class="card_bottom_text">作为专精特新企业，我们聚焦医疗科技细分需求，专注智慧医疗技术研发与产业化;以融合人工智能与生物医学工程的特色技术，打造差异化医疗解决方案。</div>
        </div>
      </div>
      <div class="card_info3">
        <div class="card_info_image">
          <img src="/status/phone/4.png">
        </div>
        <div class="card_info_right">
          <div class="card_top">
            <div class="card_text">科技型中小企业</div>
            <div class="card_title">i</div>
          </div>
          <div class="border"></div>
          <div class="card_bottom_text">作为专精特新企业，我们聚焦医疗科技细分需求，专注智慧医疗技术研发与产业化;以融合人工智能与生物医学工程的特色技术，打造差异化医疗解决方案。</div>
        </div>
      </div>
    </div>

    <div class="middle_box_list">
      <div class="text_list">
        <div class="text_text">产品中心</div>
        <div class="border"></div>
        <div class="text_title">
          Product
        </div>
      </div>
      <div class="top_list" >
        <div class="tar_info" v-for="(item,index) in tarList.slice(0,4)" :key="index" @mouseover="select(index)" @click="select(index)">
          <div class="item">{{item}}</div>
          <div class="blue" v-if="tarIndex === index"></div>
        </div>
        <div :class="gengduoIndex === 1 ? 'gengduo blue':'gengduo'" @click="goToGengDuo" @mouseleave ="mouseleaveIndex"  @mouseover="selectGengDuoIndex(1)">更多</div>
      </div>
      <div class="core_list">
        <el-carousel indicator-position="none" arrow="always" :autoplay="false" height="1550px" >
          <el-carousel-item v-for="(item,index) in coreProductList[tarIndex]" :key="index" >
            <div class="core_info" >
              <div class="image">
                <img :src="item.img">

                <img class="imgInfo" v-if="item.imgInfo" :src="item.imgInfo">
              </div>
              <div class="core_info_bottom">
                <div class="name">{{item.name}}</div>
                <div class="info">{{item.info}}</div>
                <div class="ckxq" @click="toCheck(item)">查看详情</div>
              </div>
            </div>
          </el-carousel-item>

        </el-carousel>
      </div>
    </div>


    <div class="lightModuleOuterContent">
      <div class="lightModuleOuterContent_text">
        丰富多样的营销应用助您玩转营销
      </div>
      <div class="border"></div>
      <div class="lightModuleOuterContent_title">
        Marleting
      </div>
      <div class="formTabButtonList">
        <div class="formTabButtonInfo" v-for="(item,index) in textList" :key="index" @mouseover="toText(index)" @click="toText(index)">
          {{item}}
          <div class="blue" v-if="toTextIndex === index"></div>
        </div>
      </div>
      <div class="textListInfo_list" >
        <div class="text_list_left">
          <div class="text_list_text"> {{textListInfo[toTextIndex].text}}</div>
          <div class="text_list_title"> {{textListInfo[toTextIndex].title}}</div>
        </div>
        <div class="image_right">
          <el-image
              class="imgInfo" :src="textListInfo[toTextIndex].img"
              :preview-src-list="[textListInfo[toTextIndex].img]">
          </el-image>
        </div>
      </div>
    </div>

    <div class="fullMeasureOuterContent">
      <div class="fullMeasureOuterContent_list">
        <div class="fullMeasureOuterContent_left">
          <div class="fullMeasureOuterContent_text">"互联网+医疗" 实践者</div>
          <div class="border"></div>
          <div class="fullMeasureOuterContent_info">
            利用先进的信息技术手段实现医疗资源共享，医疗数据互通，提高医疗服务治疗与效率，公司始终致力于医疗健康领域的创新和发展，在国家“互联网+医疗健康“制度的指引下,持续推动技术创新和产品升级，秉承“用科技服务人类健康”的理念，推动世界医疗健康事业发展，成为大健康行业的佼佼者。</div>
        </div>
        <div class="fullMeasureOuterContent_right">
          <div class="hezi">
            <div class="sz">100</div>
            <div class="zy">专业</div>
          </div>
          <div class="hezi">
            <div class="sz">100</div>
            <div class="zy">技术</div>
          </div>
          <div class="hezi">
            <div class="sz">100</div>
            <div class="zy">服务</div>
          </div>
        </div>
      </div>
    </div>


    <div class="news_list">
      <div class="new_top">

        <div style="font-size: 80px; color: rgb(51, 51, 51);font-weight: bold;margin-top: 20px">新闻动态</div>
        <div class="border"></div>
        <div style="font-size: 44px; color: #0D68F2;margin-top: 40px;font-weight: bold">NEWS</div>
      </div>
      <div class="new_bottom">

        <div class="new_bottom_right">
          <div class="left_info"  @click="toCheckEnt(item)" v-for="(item,index) in enterpriseList.slice(0,3)" :key="index">
            <div class="image">
              <img :src="item.img">
            </div>
            <div class="info">

              <div class="info_text">
                {{item.text}}
              </div>
              <div class="info_title" v-html="removeImagesFromHTML(item.info)"></div>
              <div class="time">
                了解详情<img src="/status/phone/10.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="fullmeasureContentBg">
      <div class="biaoti">专业智慧医疗信息化解决方案，请联系我们！</div>
      <div class="neirong">快速响应 | 精准服务 | 全流程赋能</div>
      <div class="sub" @click="goToBusinessCooperation">立即联系</div>
    </div>

    <div class="partner">
      <div class="text_list">
        <div class="text_text">合作客户</div>
        <div class="text_title">
          <i></i>
          部分合作客户
          <i></i>
        </div>
      </div>
      <div class="partner_list">
        <div class="partner_list_info">
          <img src="/newIndex/101.png">
          <div class="wenzi">湖南省第二人民医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/104.png">
          <div class="wenzi" >湖南中医药大学第二附属医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/102.png">
          <div class="wenzi">长沙市第四医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/103.png">
          <div class="wenzi">湖南省妇幼保健院</div>
        </div>

        <div class="partner_list_info">
          <img src="/newIndex/105.png">
          <div class="wenzi">长沙市第三医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/106.png">
          <div class="wenzi">湖南航天医院</div>
        </div>

        <div class="partner_list_info">
          <img src="/newIndex/107.png">
          <div class="wenzi">长沙市妇幼保健院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/108.png">
          <div class="wenzi">长沙市口腔医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/109.png">
          <div class="wenzi">湖南省中西医结合医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/110.png">
          <div class="wenzi">湖南省胸科医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/111.png">
          <div class="wenzi">中南大学湘雅三医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/113.png">
          <div class="wenzi">中南大学湘雅医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/113.jpg">
          <div class="wenzi">湖南联通</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/114.jpg">
          <div class="wenzi">湖南移动</div>
        </div>
        <!--        <div class="partner_list_info">-->
        <!--          <img src="/newIndex/115.jpg">-->
        <!--          <div class="wenzi">湘雅三医院</div>-->
        <!--        </div>-->
        <div class="partner_list_info">
          <img src="/newIndex/116.jpg">
          <div class="wenzi">国防科技大学</div>
        </div>
        <!--        <div class="partner_list_info">-->
        <!--          <img src="/newIndex/117.jpg">-->
        <!--          <div class="wenzi">株洲市监狱</div>-->
        <!--        </div>-->
        <div class="partner_list_info">
          <img src="/newIndex/118.jpg">
          <div class="wenzi">长沙市第四人民医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/119.png">
          <div class="wenzi">湖南交通医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/120.jpg">
          <div class="wenzi">雨花疾控中心</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/121.png">
          <div class="wenzi">长沙航空职业技术学院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/123.png">
          <div class="wenzi">长沙民政职业技术学院</div>
        </div>

      </div>
    </div>
    <tail_menu></tail_menu>
  </div>
</template>

<script>
import {coreProductList, enterpriseList} from '@/views/mock'
import tail_menu from "@/components/tail_menu_phone";
export default {
  name: "index",
  components:{
    tail_menu
  },
  data(){
    return{
      gengduoIndex:0,
      enterpriseList:enterpriseList,
      textListInfo:[
        {
          text:'面向医院智慧化的全面解决方案',
          title:'岳泰兴智慧医院是面向医院智慧化的全面解决方案，智慧医院以实现自动化医疗为核心，通过信息化技术、智能化设备、AI和大数据分析等现代科技手段，将传统医疗服务升级为全方位，全过程数字化、智能化和协同化的高端医疗模式。不仅可以提高医生诊疗效率和准确度，还能实现个性化医疗服务、精准预防与健康管理等，促进医患关系和谐，打造院内精细化管理为导向的医院智慧化管理系统。\n',
          img:'/newIndex/8.jpg',
        },
        {
          text:'以医院为主体的互联网医疗服务平台',
          title:'岳泰兴互联网医院是建立以医院为主体的互联网医疗服务平台，构建“线上预诊-线下面诊与治疗-线上复诊”的新型医疗模式。提供云诊室，方便医生在院外不同环境中利用互联网医院平台进行诊疗服务，充分利用“互联网+”实现多渠道预约、智能导诊、挂号、账单支付、查询、医保支付、评价等基本服务以“数据多跑路，患者少跑路”为核心，实现脱卡就诊，手机医保支付等全新服务。\n',
          img:'/newIndex/9.jpg',
        },
        {
          text:'将医疗、康复、养生和养老结合的新型医养一体化的理念',
          title:'岳泰兴智慧养老平台采用医养一体化的理念，将医疗、康复、养生和养老等为一体化，为用户提供全面的养老服务，打造机构养老与居家养老、生活照料与康复关怀相融合的全新智慧养老服务平台，覆盖全场景养老管理体系。通过岳泰兴智慧养老平台，用户可以方便地获取医疗、康复和养老等各种服务为用户打造一个舒适、安全、有趣的养老环境，以提高生活品质和健康状况。\n',
          img:'/newIndex/10.jpg',
        },
        {
          text:'医院智慧导诊导航一体解决方案',
          title:'岳泰兴智慧导诊导航一体机是为应对传统医疗导诊困境而打造的智慧医疗解决方案。传统导诊方式下，患者就医面临诸多不便，如不知如何挂号、难以找到科室位置等，严重影响就医体验。智慧导诊机功能丰富，能根据患者症状智能匹配挂号科室，提供全面的科室和医生信息查询服务，还具备院内导航与健康宣教功能。它有效提升了就医效率，缓解医院导诊压力，且可根据医院需求定制服务。该产品在优化就医流程、改善医患关系等方面发挥重要作用，有力推动了医院的智慧化建设。',
          img:'/newIndex/11.jpg',
        },
      ],
      coreProductList:coreProductList,
      tarIndex:0,
      toTextIndex:0,
      tarList:[
        '智慧医疗',
        '智慧病房',
        '智慧门诊',
        '互联网医疗'
      ],
      textList:[
        '智慧医院',
        '互联网医院',
        '智慧养老',
        '智慧导诊'
      ]
    }
  },
  methods:{

    goToGengDuo(){
      this.$router.push({name: 'coreProductPhone',query:{fid:0}})
    },
    selectGengDuoIndex(index){
      this.gengduoIndex= index
    },
    mouseleaveIndex(){
      this.gengduoIndex= 0
    },
    goToBusinessCooperation(){
      this.$router.push({name: 'businessCooperationPhone', query: {slide: 'slide'}})
    },
    toCheckEnt(item) {
      this.$router.push({name: 'enterpriseInformationInfoPhone', query: {id: item.id}})
    },
    removeImagesFromHTML(html) {
      return html.replace(/<(img|div)[^>]*>/gi, '');
    },
    select(index){
      this.tarIndex = index
    },
    toText(index){
      this.toTextIndex = index
    },
    toCheck(item) {
      this.$router.push({name: 'coreProductInfoPhone', query: {id: item.id}})
    }
  }
}
</script>

<style scoped lang="scss">
.newIndex{
  background: #F6FAFF;
}
.menu_list{
  padding: 50px 40px 50px 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-bottom: 1px solid rgba(237, 237, 237, 1);
  .menu_Info{
    padding: 50px 30px;
    width: 44%;
    display: flex;
    align-items: center;
    background: linear-gradient(to right, #FFFFFF,#ECF3FF);
    box-shadow: 0pt 2px 6px 0px rgba(184,184,184,0.4);
    margin-top: 40px;
    .img{
      width: 120px;
      height: 120px;
    }
    img{
      width: 120px;
      height: 120px;
    }
    .menu_right{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 30px;
      height: 200px;
      .text{
        font-size: 50px;
        font-weight: bold;

      }
      .border{
        width: 100px;
        height: 4px;
        background: #D8D8D8;
      }
      .title{
        font-size: 40px;
        color: rgb(153, 153, 153);;
        white-space: nowrap;
      }
    }
  }
}
.card_list{
  //border-bottom: 1px solid rgba(237, 237, 237, 1);
  padding: 60px 50px 50px 50px;
  .card_info,.card_info2,.card_info3{
    width: 100%;
    margin-bottom: 50px;
    color: white;
    display: flex;
    .card_info_image{
      width: 80px;
      height: 80px;
      margin-top: 100px;
      margin-left: 80px;
      img{
        width: 80px;
        height: 80px;
      }

    }
    .card_info_right{
      margin-top: 100px;
      margin-left: 30px;
      width: 82%;
      .card_top{
        display: flex;
        justify-content: space-between;
      }
      .card_text{
        font-size: 70px;
        font-weight: bold;

      }
      .card_title{
        font-size: 80px;
      }
      .border{
        width: 100px;
        height: 4px;
        background: white;
        margin-top: 50px;
      }
      .card_bottom_text{
        margin-top: 70px;
        font-size: 52px;
        line-height: 80px;
        margin-bottom: 80px;
      }
    }
  }
  .card_info{
    background: url("/status/phone/11.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .card_info2{
    background: url("/status/phone/12.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .card_info3{
    background: url("/status/phone/13.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}


.middle_box_list{
  display: flex;
  align-items: center;
  flex-direction: column;
  //padding: 0 60px 60px 60px;

  .text_list{
    display: flex;
    align-items: center;
    flex-direction: column;
    .text_text{
      font-size: 80px;
      font-weight: bold;
      color: #222222;
      text-align: center;
    }
    .border{
      margin-top: 30px;
      width: 100px;
      height: 10px;
      background: #0D68F2;
    }
    .text_title{
      margin-top: 40px;
      font-size: 48px;
      text-align: center;
      color: #0D68F2;
      font-weight: bold;

    }
  }
  .top_list{
    display: flex;
    justify-content: space-around;
    width: 100%;
    background: #0D68F2;
    color: white;
    padding: 80px 0 60px 0;
    margin-top: 80px;
    .gengduo{
      white-space: nowrap;
      //cursor: pointer;
      font-size: 60px;
    }
    .tar_info{
     display: flex;
      flex-direction: column;
      align-items: center;
      //cursor: pointer;
      font-size: 60px;
      .item{
        white-space: nowrap;
      }

    }
    .blue{
      width: 100px;
      height: 8px;
      background: white;
      margin-top: 20px;
    }
  }
  .core_list{
    width: 100%;

    .core_info{
      padding: 80px 50px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .image{
        width: 900px;
        position: relative;
        img{
          width: 900px;
        }
        .imgInfo{
          position: absolute;
          width: 650px;
          top: 120px;
          left: 120px;
        }
      }
      .core_info_bottom{
        box-shadow: 0px 4px 10px 10px #e7e5e5;
        width: 900px;
        padding: 30px 0 80px 0;
        background: white;
        .name{
          font-size: 70px;
          text-align: center;
          font-weight: bold;
          border-bottom: 6px solid #F3F3F3;
          padding-bottom: 30px;
        }
        .info{
          font-size: 44px;
          margin: 40px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          color: #ababab;
        }
        .ckxq{
          width: max-content;
          margin: 50px auto 0 auto;
          background: #0D68F2;
          font-size: 46px;
          color: white;
          padding: 20px 40px;
        }
      }

    }


  }
}

.lightModuleOuterContent{
  margin-top: 50px;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 60px 0;
  .border{
    margin-top: 30px;
    width: 100px;
    height: 10px;
    background: #0D68F2;
  }
  .lightModuleOuterContent_text{
    font-size: 80px;
    font-weight: bold;
    color: rgb(51, 51, 51);
  }
  .lightModuleOuterContent_title{
    color: #0D68F2;
    font-size: 48px;
    margin-top: 30px;
    font-weight: bold;
  }
  .formTabButtonList{
    //width: 1200px;
    width: 100%;
    background: #0D68F2;
    display: flex;
    justify-content: space-around;
    margin-top: 80px;
    .formTabButtonInfo{
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: 微软雅黑;
      color: white;
      font-size: 56px;
      font-weight: bold;
      //font-weight: normal;
      padding: 100px 60px 72px 60px;
      cursor: pointer;
      white-space: nowrap;
    }
    .blue{
      width: 100px;
      height: 8px;
      background: white;
      margin-top: 20px;
    }
  }
  .textListInfo_list{
    background-image: url("/status/phone/1.png");
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat: no-repeat;
    padding: 40px 0 0 0;
    width: 100%;
    .text_list_left{
      margin: 50px 80px;
      .text_list_text{
        font-size: 74px;
        color: rgb(51, 51, 51);
        margin-bottom: 30px;
        font-weight: bold;
      }
      .text_list_title{
        width: 100%;
        font-size: 52px;
        line-height: 78px;
        display: inline-block;
        color: rgb(153, 153, 153);
        margin-top: 50px;
      }
    }
    .image_right{
      margin: 0 80px;
      animation: ceshi 2s forwards;
      .imgInfo{
        margin-top: 50px;
        width: 100%;
        height: 1000px;
      }
    }
  }
}

.fullMeasureOuterContent{
  background-image: url("/status/phone/16.png");
  padding: 100px 0;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 80px;
  .fullMeasureOuterContent_list{
    .fullMeasureOuterContent_left{
      margin-left: 80px;
      .fullMeasureOuterContent_text{
        font-size: 74px;
        color: rgb(255, 255, 255);
      }
      .border{
        width: 100px;
        height: 4px;
        margin-top: 40px;
        background: white;
      }
      .fullMeasureOuterContent_info{
        margin-top: 50px;
        margin-right: 80px;
        font-size: 52px;
        color: rgb(255, 255, 255);
        line-height: 80px;
      }

    }
    .fullMeasureOuterContent_right{
      margin: 50px 100px 50px 80px;
      padding: 100px 50px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      background: white;
      .hezi{
        border-right: 2px solid rgb(232,232,232);
        padding: 0 120px;
      }
      .hezi:last-child{
        border: none;
      }
      .sz{
        font-size: 120px;
        font-weight: bold;
        color: #0D68F2;
      }
      .zy{
        font-size: 52px;
        //color: rgb(153, 153, 153);
        text-align: center;
      }
    }
  }

}

.news_list{
  margin-top: 20px;
  padding: 60px;
  .new_top{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-bottom: 20px;
    .border{
      margin-top: 30px;
      width: 100px;
      height: 10px;
      background: #0D68F2;
    }
  }
  .new_bottom{
    width: 100%;
    padding: 40px 0;
    .new_bottom_right{
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .left_info{
        margin-bottom: 50px;
        cursor: pointer;
        background-image: url("/status/phone/5.png");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        box-shadow: 0px 4px 5px 5px #f3f1f1;
        .image{

          img{
            width: 100%;
            height: 800px;
          }
        }
        .info{
          margin-left: 50px;
        }
        .info_text{
          font-weight: bold;
          color: #333;
          font-size: 66px;
          margin-top: 50px;
          margin-right: 50px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .info_title{
          //width: 500px;
          color: #666;
          font-size: 48px;
          margin-top: 50px;
          margin-right: 50px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          margin-bottom: 50px;
        }
        .time{
          font-size: 54px;
          margin-top: 50px;
          margin-bottom: 50px;
          color: #0D68F2;
          img{
            width: 80px;
            margin-left: 30px;
          }
        }
      }
    }
  }
}
.fullmeasureContentBg{
  background-image: url("/newIndex/14.jpg");
  height: 400px;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding: 140px 0;
  .biaoti{
    font-size: 64px;
  }
  .neirong{
    font-size: 60px;
  }
  .sub{
    background: rgba(7, 108, 224, 1);
    color: white;
    border-radius: 10px;
    font-size: 44px;
    width: 400px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    cursor: pointer;
  }
}

.partner{

  padding: 60px 0;
  .text_list{
    .text_text{
      margin-top: 50px;
      font-size: 78px;
      font-weight: bold;
      color: #222222;
      text-align: center;
    }
    .text_title{
      margin-top: 20px;
      margin-bottom: 10px;
      font-size: 56px;
      text-align: center;
      color: #666666;
      i{
        display: inline-block;
        vertical-align: middle;
        width: 194px;
        height: 2px;
        background: #A6A6A6;
        margin: 0 25px;
      }
    }
  }
}

.partner_list{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 150px 0 50px;
  .partner_list_info{
   width: 50%;
    display: flex;
    align-items: center;
    margin-top: 40px;
    .wenzi{
      margin-left: 20px;
      font-size: 44px;
      font-family: '楷体';
      white-space: nowrap;
    }
    img{
      width: 200px;
    }
  }
}


::v-deep .el-carousel__arrow--right{
  width: 200px;
  height: 200px;
  border-radius: 10px;
  background: #0D68F2;
  right: 50px;
}
::v-deep .el-carousel__arrow--right .el-icon-arrow-right{
  width: 100px;
  height: 50px;
  background: url("/status/phone/14.png");
  background-repeat: no-repeat;
  background-size: 100%;
  font-size: 0;
}
::v-deep .el-carousel__arrow--left{
  width: 200px;
  height: 200px;
  border-radius: 10px;
  background: #EEEEEE;
  left: 50px;
}
::v-deep .el-carousel__arrow--left .el-icon-arrow-left{
  width: 100px;
  height: 50px;
  background: url("/status/phone/15.png");
  background-repeat: no-repeat;
  background-size: 100%;
  font-size: 0;
}
</style>
